import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
import { IKartverketAddress, KartverketAddressExtensionClass } from './entities/kartverket-address';

function searchAddressQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function searchAddressInput(queryResultSettings: IQueryResultSettings, searchTerm: string): IDataServiceRequest {
    const query = searchAddressQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchAddress',
        false,
        KartverketAddressExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'IKartverketAddress' },
        { searchTerm }
    );
}

export function searchAddressAsync(context: IContext, searchTerm: string): AsyncResult<IKartverketAddress[]> {
    return callActionOrExecute<IKartverketAddress[]>(
        searchAddressInput(context.queryResultSettings || {}, searchTerm),
        context.callerContext
    );
}
